import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Mission } from 'src/app/shared/models/mission/mission';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class MeetingService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getMultipleEmployeeMissionById(id: number): Observable<Mission> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionWithMultipleEmployeeUrl}/${id}`,
			'getMultipleEmployeeMissionById'
		);
	}

	deleteMeetingById(id: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.formationUrl}/${id}`,
			`deleteMeetingById`
		);
	}

	deleteMultipleEmployeeEventById(id: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.missionWithMultipleEmployeeUrl}/${id}`,
			`deleteMultipleEmployeeEventById`
		);
	}

	updateMultipleEmployeeMission(meeting: Mission): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionWithMultipleEmployeeUrl}`,
			`updateMultipleEmployeeMission`,
			meeting
		);
	}

	updateNumberOfIntervenantOfMissionWithMultipleIntervenants(
		missionRequestId: number,
		numberOfEmployee: number
	): Observable<void> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionWithMultipleEmployeeUrl}/${missionRequestId}/${numberOfEmployee}`,
			`updateMultipleEmployeeMission`
		);
	}
}
